import { useCohortBuilderData } from '@verantos-dev/data-access-cohorts';
import { PageHeader } from '@verantos-dev/shared-components';

import { useActivePageTab } from './hooks/useActivePageTab';
import { useCohortBuilderPageActions } from './hooks/useCohortBuilderPageActions';
import { useCohortBuilderPageBreadcrumbs } from './hooks/useCohortBuilderPageBreadcrumbs';
import { useCohortBuilderPageTabs } from './hooks/useCohortBuilderPageTabs';
import { CohortInfoBar } from '../../../../components/CohortInfoBar/CohortInfoBar';
import { ProcessCohortDefinitionModal } from '../../../../components/ProcessCohortDefinitionModal/ProcessCohortDefinitionModal';
import { SaveCohortDefinitionModal } from '../../../../components/SaveCohortDefinitionModal/SaveCohortDefinitionModal';
import {
  CohortBuilderActionDialogType,
  useCohortBuilderModalContext,
} from '../../../../contexts/CohortBuilderModalContext';
import CohortExitModal from '../CohortBuilderExitModal/CohortExitModal';

export const CohortBuilderPageHeader = () => {
  const { data, projectData } = useCohortBuilderData();
  const activePageTab = useActivePageTab();
  const pageTabs = useCohortBuilderPageTabs(activePageTab);
  const breadcrumbs = useCohortBuilderPageBreadcrumbs(
    projectData?.data?.projectName || '',
    data?.data?.cohortName || ''
  );
  const actions = useCohortBuilderPageActions(activePageTab);
  const { activeDialog } = useCohortBuilderModalContext();

  return (
    <>
      <PageHeader
        id="cohort-builder-page-header"
        pageTitle={data?.data?.cohortName || ''}
        breadcrumbs={breadcrumbs}
        actions={actions}
        pageTabs={pageTabs}
        infoBarContainer={
          <CohortInfoBar
            cohortStatus={data?.data?.latestStatus}
            datasetReleaseId={data?.data?.latestDatasetReleaseId}
            datasetReleaseName={data?.data?.latestDatasetReleaseDisplayName}
            ownerFirstName={data?.data?.createdBy.firstName}
            ownerLastName={data?.data?.createdBy.lastName}
            subjectCount={data?.data?.latestSubjectCount}
          />
        }
      />
      {activeDialog === CohortBuilderActionDialogType.PROCESS_COHORT_DEFINITION && (
        <ProcessCohortDefinitionModal />
      )}
      {activeDialog === CohortBuilderActionDialogType.SAVE_COHORT_DEFINITION && (
        <SaveCohortDefinitionModal />
      )}
      {activeDialog === CohortBuilderActionDialogType.EXIT_COHORT_DEFINITION && <CohortExitModal />}
    </>
  );
};
